// services/ContactService.ts
import { authCall } from '.'
import { contactUs } from './endpoints'
import { ContactUsRequest, ContactUsResponse } from '../interfaces/contact'

const ContactService = {
  sendMessage: (data: ContactUsRequest) => {
    return authCall<ContactUsResponse>({
      url: contactUs,
      method: 'post',
      data,
    })
  },
}

export default ContactService
